export default __webpack_public_path__ + "static/media/chatTransfer.e6dd633b.svg";